import * as React from 'react';
import { t } from '@moovly/i18n';
import { FileDrop } from '@moovly/ui';
import { getLogo } from '../../utils/logo';
import { SettingsPanel, useSettingUpdate } from '@moovly/moovly-settings';
import { getInputAcceptString, UploadOptions } from '@moovly/clients';

const LogoImgStyleBlack = {
  maxHeight: 70,
  padding: 20,
  backgroundColor: '#212329',
  width: 'min-content',
};

const LogoSettings = () => {
  const { value: image, onUpdate } = useSettingUpdate<string>('editor_customisation.logo');
  const handleUploadLogo = React.useCallback(
    async (file: File) => {
      if (!!file) {
        const logo = await getLogo(file);
        if (['sprite', 'svg'].includes(logo.type)) {
          // @ts-ignore
          const { path } = logo.assets[0];
          onUpdate(path);
        }
      }
    },
    [onUpdate]
  );
  return (
    <SettingsPanel title={t('settings.editor.logo')}>
      <div className="d-flex align-items-center justify-content-evenly">
        {image && <img style={LogoImgStyleBlack} alt="Uploaded" src={image} className="mb-2" />}
        <FileDrop
          value={null}
          label={t('settings.logo.upload')}
          onChange={handleUploadLogo}
          accept={getInputAcceptString(UploadOptions.IMAGE)}
        />
      </div>
    </SettingsPanel>
  );
};
export default LogoSettings;
